export default "__VITE_ASSET__4ac5fc94__$_?component__"